<!-- =========================================================================================
  File Name: ExhibitorList.vue
  Description: Exhibitor List Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
button.vs-component.vs-button.ml-3.setting-btn.vs-button-primary.vs-button-border {
  padding: 6px !important;
}
.setting-btn span img {
  height: 20px;
  width: 20px;
}
.file-up-section {
  text-align: center;
  border: 2px dashed #c8c8c8;
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}
.file-up-section p {
  color: #4c8af6;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}
.header-custome {
  margin-bottom: 15px;
  padding-left: 2px;
}
</style>
<template>
  <div id="page-user-list">
    <div class="header-custome">
      <h3>Mail Templates</h3>
    </div>

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ mailtplData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : mailtplData.length }} of {{ mailtplData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!--ADD -->
        <vs-button type="gradient mr-4" v-on:click="addRecord ()">Add Mail Template</vs-button>
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />

        <!-- ACTION - DROPDOWN -->
        <!-- <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu> -->
            <!--
              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>CSV</span>
                </span>
              </vs-dropdown-item>
            -->
          <!-- </vs-dropdown-menu>
        </vs-dropdown> -->
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="mailtplData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>

    <vs-popup fullscreen
      class="holamundo"
      title="Delivery Report"
      :active.sync="popupActive"
    >
    <!--
      <vs-table :data="reportData">
          <template slot="thead">
            <vs-th>From Email</vs-th>
            <vs-th>Subject</vs-th>
            <vs-th>To Email</vs-th>
            <vs-th>Status</vs-th>
            <vs-th>Opens Count</vs-th>
            <vs-th>Clicks Count</vs-th>
            <vs-th>Last Event Time</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
              <vs-td>{{data[indextr].from_email}} </vs-td>
              <vs-td>{{data[indextr].subject}} </vs-td>              
              <vs-td>{{data[indextr].to_email}} </vs-td>              
              <vs-td>{{data[indextr].status}} </vs-td>              
              <vs-td>{{data[indextr].opens_count}} </vs-td>              
              <vs-td>{{data[indextr].clicks_count}} </vs-td>              
              <vs-td>{{ SetTimeByZone(new Date(data[indextr].last_event_time).toUTCString(), Session_Event_TZ) }} </vs-td>              
            </vs-tr>
          </template>
      </vs-table>
      -->
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mt-4">
          <vs-input class="w-full" v-model="ReportSubject" />
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4">
          <vs-button type="gradient mr-4" v-on:click="fetchdeliveryReport">Get Report</vs-button>
          <vs-button type="gradient mr-4" @click="gridApi2.exportDataAsCsv()" color="dark">Export</vs-button>
        </div>
      </div>
      <ag-grid-vue 
        :components="components"    
        :gridOptions="gridOptions2"    
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs2"  
        :defaultColDef="defaultColDef"      
        :rowData="reportData"     
        :floatingFilter="true"   
      ></ag-grid-vue>      
    </vs-popup>

  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import moment from "moment-timezone";

import con from "@/firebase/firebaseInit.ts";

// Store Module
import moduleMailtplManagement from "@/store/mailtpl-management/moduleMailtplManagement.js";
import moduleClientManagement from "@/store/client-management/moduleClientManagement.js";
import bu from "@/store/bulkupload/BulkUpload.js";
import ls from "@/common/localStorage";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import CellRendererActionsReport from "./cell-renderer/CellRendererActionsReport.vue";
import CellRendererPreviewActions from "./cell-renderer/CellRendererPreviewActions.vue";

var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ")
let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id");

//console.log(db);

export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    CellRendererActionsReport,
    CellRendererPreviewActions,
    moment
  },
  data() {
    return {
      Environment: con.Environment,
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" }
      ],
      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" }
      ],
      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" }
      ],
      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" }
      ],
      searchQuery: "",
      reportData: [],
      ReportSubject: null,
      DocName: null, 
      CollectionName: null,
      popupActive: false,
      popupActive2: false,
      ClientDetails: null,
      // AgGrid
      gridApi: null,
      gridOptions: {},
      gridOptions2: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs2: [
        {
          headerName: "From Email",
          field: "from_email",
          filter: true,
          width: 200
        },
        {
          headerName: "Subject",
          field: "subject",
          filter: true,
          width: 300
        },
        {
          headerName: "To Email",
          field: "to_email",
          filter: true,
          width: 200          
        },
        {
          headerName: "Status",
          field: "status",
          filter: true,
          //width: 100          
        },
        {
          headerName: "Opens Count",
          field: "opens_count",
          filter: true,
          //width: 300          
        },
        {
          headerName: "Clicks Count",
          field: "clicks_count",
          filter: true,
          //width: 300          
        },
        {
          headerName: "Last Event Time",
          field: "last_event_time",
          cellRenderer: data => {
            return data.value ? this.SetTimeByZone(new Date(data.value).toUTCString(),Session_Event_TZ): '';
          },
          filter: true,
          width: 300
        }        
      ],
      columnDefs: [
        {
          headerName: "Template Group",
          field: "CollectionName",
          filter: true,
          width: 300
        },
        {
          headerName: "Template Name",
          field: "DocName",
          filter: true,
          width: 300
        },        
        {
          headerName: "Edit",
          field: "transactions",
          width: 150,          
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: params => {
            return {
              DocName: params.data.DocName,
              CollectionName: params.data.CollectionName
            };
          }
        },
        {
          headerName: "Preview",
          field: "transactions",
          width: 150,          
          cellRendererFramework: "CellRendererPreviewActions",
          cellRendererParams: params => {
            return {
              DocName: params.data.DocName,
              CollectionName: params.data.CollectionName
            };
          }
        },
        {
          headerName: "Delivery Report",
          field: "report",
          hide: true,
          width: 200,
          cellRendererFramework: "CellRendererActionsReport",
          cellRendererParams: params => {
            return {
              DocName: params.data.DocName,
              CollectionName: params.data.CollectionName
            };
          }
        }
      ],
      
      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions
      }
    };
  },
  watch: {
    roleFilter(obj) {
      this.setColumnFilter("role", obj.value);
    },
    statusFilter(obj) {
      this.setColumnFilter("status", obj.value);
    },
    isVerifiedFilter(obj) {
      const val =
        obj.value === "all" ? "all" : obj.value === "yes" ? "true" : "false";
      this.setColumnFilter("is_verified", val);
    },
    departmentFilter(obj) {
      this.setColumnFilter("department", obj.value);
    }
  },
  computed: {
    mailtplData() {
      if(this.Environment != 'EDU')
        return this.$store.state.mailtplManagement.mailtpls
      else
        return this.$store.state.mailtplManagement.mailtpls.filter(item=> ['ReminderMail', 'Speaker'].includes(item.CollectionName));
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    }
  },
  methods: {
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },
    openReportPopUp(res){
      if(res.data)
      {
        this.reportData = res.data
        this.ReportSubject = res.data[0].subject
        this.popupActive = true;
        this.DocName = res.DocName
        this.CollectionName = res.CollectionName
      }
    },
    fetchdeliveryReport(){
      this.$vs.loading();
      this.reportData = null
      let Subject = this.ReportSubject
      let DocName = this.DocName
      let CollectionName = this.CollectionName
      this.$store.dispatch("mailtplManagement/fetchdeliveryReport", {DocName: DocName, CollectionName: CollectionName, Subject: Subject}).then(res => {  
        this.$vs.loading.close();
        if(res.data)
          this.reportData = res.data.result.messages
      })
    },
    addRecord() {
      this.$router.push(`/mailtpl/add`).catch(() => {});
    },
    // editRecord () {
    //   this.$router.push(`/event/exhibitor/add/${268}`).catch(() => {})
    // },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all"
      };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    fetchClient(){
      this.$store
        .dispatch("clientManagement/fetchClient", Session_Client_Id)
        .then((res) => {
          if (res.status == 200) {
            this.ClientDetails = res.data;
            this.gridOptions.columnApi.setColumnVisible('report', res.data.CustomSMTP ? false : true)   
          }
        });
    }
  },
  mounted() {
    this.gridOptions.api.showLoadingOverlay()
    this.gridApi = this.gridOptions.api;
    this.gridApi2 = this.gridOptions2.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
    this.$root.$on("openReportPopUp", this.openReportPopUp)
  },
  created() {
    if (!moduleMailtplManagement.isRegistered) {
      this.$store.registerModule("mailtplManagement", moduleMailtplManagement);
      moduleMailtplManagement.isRegistered = true;
    }
    this.$store.dispatch("mailtplManagement/fetchMailtpls").catch(err => {
      console.error(err);
    });
    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
    this.fetchClient();  
    
  }
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>